module.exports = __webpack_public_path__ + "static/img/gdurl.com.058d065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/gdurl.com.jpg
// module id = 32
// module chunks = 1